import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Spin, Table } from 'antd';
import { useAuth } from '../../hooks/AuthProvider';
import { Balance } from './Balance';
import { buildPagination, DEFAULT_PAGINATION_PARAMS } from '../shared/build-pagination';
import { formatDate, getAmountStyle } from '../shared/helpers';
import { fetchBalance, fetchMovements } from './requests';

export function UserMovementsRegular({ userId }) {
  const auth = useAuth();
  const [loading, setLoading] = useState(false);
  const [movements, setMovements] = useState([]);
  const [paginationOptions, setPaginationOptions] = useState({ ...DEFAULT_PAGINATION_PARAMS });
  const [highestBalance, setHighestBalance] = useState();

  const performFetchMovements = () => fetchMovements({ userId, paginationOptions, onFinish: setMovements, setLoading, auth });
  const performFetchBalance = () => fetchBalance({ userId, onFinish: setHighestBalance, auth });

  useEffect(() => {
    performFetchMovements();
    performFetchBalance();
  }, [auth, userId, paginationOptions]);

  const handlePaginate = (pageNumber, size) =>
    setPaginationOptions({
      ...paginationOptions,
      size,
      page: pageNumber - 1,
    });

  const columns = [
    {
      title: 'Data',
      dataIndex: 'date',
      key: 'date',
      render: (date) => formatDate(date),
      width: 120,
    },
    {
      title: 'Valor',
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => <span style={getAmountStyle(amount)}>R${amount}</span>,
      width: 120,
    },
    {
      title: 'Saldo',
      dataIndex: 'balanceAfterMovement',
      key: 'balanceAfterMovement',
      render: (balanceAfterMovement) => <span style={getAmountStyle(balanceAfterMovement)}>R${balanceAfterMovement}</span>,
      width: 120,
    },
    {
      title: 'Observação',
      dataIndex: 'observation',
      key: 'observation',
      ellipsis: true,
    },
  ];

  if (loading) return <Spin size="large" />;

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={8}>
            <Card title="Saldo Atual" size="small">
              <Balance balance={highestBalance} />
            </Card>
          </Col>
        </Row>
      </Col>

      <Col span={24}>
        <Table columns={columns} dataSource={movements.content} pagination={buildPagination(movements, handlePaginate)} />
      </Col>
    </Row>
  );
}
